// extracted by mini-css-extract-plugin
export var chevron = "_i3-2";
export var dropdownItems = "_i3-0";
export var item = "_i3-1";